import { gql } from 'graphql-request';
import { useRequestGQLQuery } from './useGraphQLQuery';


export const GQL_GLOBAL_PERMISSION_TEMPLATES = `global_permission_templates {
  id
  object_meta
  permission
  title
  options
  metadata
  category
  description
  created_at
  updated_at
}`

export const GQL_NAMESPACES = `namespaces {
  id
  object_meta
  site_settings{
    metadata
  }
  created_at
  updated_at
}`

export const GQL_GLOBAL_FEATURES = `global_features {
  id
  description
  name
  category
  permission_templates
  title
  type_meta
  object_meta
  created_at
  updated_at
}`

export const CREATE_OR_UPDATE_PERMISSION_TEMPLATES = `mutation createOrUpdatePermissionTemplates($data: [global_permission_templates_insert_input!]!) {
  insert_global_permission_templates(
    objects: $data, 
    on_conflict: {
      constraint: global_permission_templates_pkey, 
      update_columns: [
        object_meta,
        permission,
        title,
        options,
        metadata,
        category,
        description,
        updated_at
      ]
    }
  ) {
      returning {
        id
        object_meta
        permission
        title
        options
        metadata
        category
        description
        created_at
        updated_at
      }
    }
  }`


export const DELETE_PERMISSION_TEMPLATES = `mutation deletePermissionTemplates($uid: bigint) {
  delete_global_permission_templates(where: {id: {_eq: $uid} }) {
  affected_rows
  }
}`


export const CREATE_OR_UPDATE_FEATURES = `mutation createOrUpdateFeatures($data: [global_features_insert_input!]!) {
  insert_global_features(
    objects: $data,
    on_conflict: {
      constraint: global_features_pkey, 
      update_columns: [
        description,
        name,
        category,
        permission_templates,
        title,
        type_meta,
        object_meta,
        updated_at
      ]
    }
  ) {
      returning {
        id
        description
        name
        category
        permission_templates
        title
        type_meta
        object_meta
        created_at
        updated_at
      }
    }
  }`


export const DELETE_FEATURES = `mutation deleteFeatures($uid: bigint) {
  delete_global_features(where: {id: {_eq: $uid} }) {
  affected_rows
  }
}`

const GET_PERMISSION_TEMPLATES_BY_NAMES = gql`query describeGlobalPermissions {
  ${GQL_GLOBAL_PERMISSION_TEMPLATES}
}`;

export const GQLGetPermissionTemplatesByNames = (variables: any) => {
  const result = useRequestGQLQuery(GET_PERMISSION_TEMPLATES_BY_NAMES, variables);
  return result;
};

const GET_FEATURES_BY_NAMESPACE = gql`query describeGlobalFeatures {
  ${GQL_GLOBAL_FEATURES}
}`;

export const GQLGetFeaturesByNamespace = (variables: any) => {
  const result = useRequestGQLQuery(GET_FEATURES_BY_NAMESPACE, variables);
  return result;
};